(() => {
  const STORAGE_KEY = 'comely_wishlist_variants';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    window.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { wishlist: list } })
    );
  }

  function add({ variant_id, product_handle }) {
    const list = getWishlist();
    if (!list.some(i => i.variant_id === variant_id)) {
      list.push({ variant_id, product_handle });
      saveWishlist(list);
    }
  }

  function remove(variant_id) {
    saveWishlist(getWishlist().filter(i => i.variant_id !== variant_id));
  }

  function toggle({ variant_id, product_handle }) {
    has(variant_id)
      ? remove(variant_id)
      : add({ variant_id, product_handle });
  }

  function has(variant_id) {
    return getWishlist().some(i => i.variant_id === variant_id);
  }

  window.ComelyWishlist = { get: getWishlist, add, remove, toggle, has };
})();


  document.addEventListener('click', (e) => {
  
  const btn = e.target.closest('[data-wishlist-toggle]');
  if (!btn || !window.ComelyWishlist) return;
   if (!btn.contains(e.target)) return;
  const card = btn.closest('product-card');
if (card) {
  card.dataset.wishlistLock = 'true';
}

  e.preventDefault();
  e.stopPropagation();

  if (btn.dataset.busy === 'true') return;
  btn.dataset.busy = 'true';

  const variant_id = Number(btn.dataset.variantId);
  const product_handle = btn.dataset.productHandle;

  const wasActive = btn.classList.contains('is-active');

  // UI ottimistica immediata
  btn.classList.toggle('is-active', !wasActive);
  btn.setAttribute('aria-pressed', String(!wasActive));

  // storage
  if (wasActive) {
    ComelyWishlist.remove(variant_id);
  } else {
    ComelyWishlist.add({ variant_id, product_handle });
  }

  requestAnimationFrame(() => {
      if (card) delete card.dataset.wishlistLock;
  delete btn.dataset.busy;
  });
});
document.addEventListener('pointerdown', (e) => {
  const btn = e.target.closest('[data-wishlist-toggle]');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();
}, { capture: true });

  window.addEventListener('DOMContentLoaded', () => {
    if (!window.ComelyWishlist) return;

    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const variant_id = Number(btn.dataset.variantId);
      const isActive = ComelyWishlist.has(variant_id);
      btn.setAttribute('aria-pressed', String(isActive));
      btn.classList.toggle('is-active', isActive);
    });
  });